<script setup>
import { ref, computed } from 'vue'

import { getI18n } from '@/plugins/i18n'
import { useDetectDevice } from '@/composables/device'
import { useAccountingStore } from '@/stores/accounting.store'
import { usePortalStore } from '@/stores/portal.store'

const props = defineProps({
  draft: {
    type: Object,
    default: null,
  },
  kinds: {
    type: Array,
    required: true,
  },
  locationKind: {
    type: Number,
    default: null,
  },
})

const emit = defineEmits(['confirm', 'cancel'])

const i18n = getI18n()
const { isMobile } = useDetectDevice()
const accountingStore = useAccountingStore()
const portalStore = usePortalStore()

const tag = ref({})
const onBeforeShow = async() => {
  tag.value = { name: props.draft.name, kind: props.kinds[0].id, subdivision_code: null }
  if (props.locationKind === null || subdivisions.value.length) return
  subdivisions.value = (await portalStore.fetchCountrySubdivisionsAsync(accountingStore.companyData.country)).map(item => ({ label: `${item.name} (${item.code})`, value: item.code }))
  subdivisionOptions.value = subdivisions.value
}
const subdivisions = ref([])
const subdivisionOptions = ref([])
const isLocation = computed(() => props.locationKind !== null && tag.value.kind === props.locationKind)

const onSubdivisionFilter = (value, update) => update(() => {
  const needle = (value || '').toLowerCase()
  subdivisionOptions.value = subdivisions.value.filter(item => !needle || item.label.toLowerCase().includes(needle))
})

</script>

<template>
  <q-dialog
    :model-value="props.draft !== null"
    class="dialog-xxs"
    @before-show="onBeforeShow"
    @hide="emit('cancel')"
  >
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="mdi-tag-plus-outline" color="primary" text-color="white" />
        <span class="text-h6 q-ml-sm">{{ i18n.t('common.newTag') }}</span>
      </q-card-section>
      <q-card-section class="q-pt-none">
        <div class="row q-col-gutter-sm">
          <q-input
            v-model="tag.name"
            :class="isMobile ? 'col-12' : 'col-6'"
            :label="i18n.t('common.name')"
            autofocus
          />
          <div :class="isMobile ? 'col-12' : 'col-6'" class="flex items-center">
            <q-toggle
              v-model="tag.kind"
              :true-value="props.kinds[1].id"
              :false-value="props.kinds[0].id"
              :label="props.kinds[1].name"
            />
          </div>
          <q-select
            v-if="isLocation"
            v-model="tag.subdivision_code"
            class="col-12"
            :label="i18n.t('common.province')"
            :options="subdivisionOptions"
            use-input
            clearable
            emit-value
            map-options
            @filter="onSubdivisionFilter"
          />
        </div>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat :label="i18n.t('common.cancel')" @click="emit('cancel')" />
        <q-btn
          color="primary"
          :label="i18n.t('common.confirm')"
          :disable="!tag.name"
          @click="emit('confirm', tag)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
